"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagaluService = exports.extractParam = exports.isSuccess = void 0;
const mocks_1 = require("./mocks");
/**
 * An wrapper for MiniApps to interact with Magazine Luiza's SuperApp
 */
class MagaluService {
    /**
     * @ignore
     */
    constructor() { }
    static request({ serviceName, serviceArgs, callbackId, callback, showLoading }, mockMode) {
        var _a;
        if (!this.didFoundSDK()) {
            console.warn("didn't found any sdk");
            return;
        }
        const id = callbackId || (Math.random() + new Date().getTime()).toString();
        if (id && callback) {
            this.callbacks.set(id, callback);
        }
        let isUsingPromise = callback === undefined;
        if (mockMode) {
            const response = this.returnMockedResponse(serviceName, id);
            if (isUsingPromise) {
                return Promise.resolve(response);
            }
            else {
                this.pushResponse(response);
            }
        }
        try {
            const argsString = JSON.stringify(serviceArgs);
            const payload = {
                callbackId,
                serviceName,
                authId: (_a = this.hash) !== null && _a !== void 0 ? _a : '',
                arguments: argsString,
                showLoading
            };
            const message = JSON.stringify(payload);
            if (isUsingPromise) {
                const promise = this.buildPromise(id);
                this.callSDK(message, id);
                return promise;
            }
            else {
                this.callSDK(message, callbackId);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    static returnMockedResponse(serviceName, callbackId) {
        let bodyResponde;
        switch (serviceName) {
            case 'customer.getCustomerInfo':
                bodyResponde = mocks_1.customerInfo;
                break;
            case 'customer.getCustomerAddress':
                bodyResponde = mocks_1.adresses;
                break;
            case 'customer.getCustomerLocation':
                bodyResponde = mocks_1.zipCode;
                break;
        }
        return {
            callbackId: callbackId || '',
            code: 200,
            body: bodyResponde,
        };
    }
    static buildPromise(callbackId) {
        return new Promise((resolve, reject) => {
            this.callbacks.set(callbackId || '', (result) => {
                if (isSuccess(result)) {
                    resolve(result.body);
                }
                else {
                    reject({
                        code: result.code,
                        message: result.message
                    });
                }
            });
        });
    }
    static didFoundSDK() {
        var _a, _b, _c;
        return ((_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.magaluSdk)
            || ((_c = window === null || window === void 0 ? void 0 : window.magaluSdk) === null || _c === void 0 ? void 0 : _c.requestService);
    }
    static callSDK(message, callbackId) {
        var _a, _b, _c;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.magaluSdk) {
            window.webkit.messageHandlers.magaluSdk.postMessage(message);
        }
        else if ((_c = window === null || window === void 0 ? void 0 : window.magaluSdk) === null || _c === void 0 ? void 0 : _c.requestService) {
            window.magaluSdk.requestService(message);
        }
        else {
            console.warn("didn't found any sdk");
            callbackId && this.callbacks.delete(callbackId);
        }
    }
    /**
     * @param {string} callbackId - The id of the callback to be removed
     */
    static unregister(callbackId) {
        this.callbacks.delete(callbackId);
    }
    /**
     * Wipes all the callbacks
     */
    static unregisterAll() {
        this.callbacks.clear();
    }
    /**
     * @protected
     * @param {ServiceResponse} response - An object that wrap all the data from a service computation
     *
     * This method is called from the native SDKs, don't call it yourself
     */
    static pushResponse(response) {
        try {
            const callback = this.callbacks.get(response.callbackId);
            if (!callback) {
                return;
            }
            return callback(response);
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * @param {ServiceCallback} callback - Called when a custom button has been touched
     */
    static registerNavbarActionsCallback(callback) {
        if (callback) {
            this.callbacks.set('appbar.actionPressed', callback);
        }
    }
}
exports.MagaluService = MagaluService;
/**
 * @readonly
 * A token generated on the backend */
MagaluService.jwt = extractParam('jwt');
/**
 * @readonly
 * @public
 * Hashed value for the MiniApp */
MagaluService.hash = extractParam('hash');
/**
* @deprecated Use `miniapp.deeplink` service instead
*/
MagaluService.deeplink = extractParam('deeplink');
/**
 * @readonly
 * @private
* Mapping from `callbackId` to a `callback` function */
MagaluService.callbacks = new Map();
/**
 * @param {ServiceResponse} result - a response from the SDK
 * @returns true if the result code is between 200...299
 */
function isSuccess(result) {
    return result.code >= 200 && result.code < 300;
}
exports.isSuccess = isSuccess;
/**
 * @param {string} value - key to be extract from the session storage
 */
function extractParam(value) {
    if (typeof window === 'undefined') {
        return null;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let param = urlParams.get(value);
    if (param === null || param === void 0 ? void 0 : param.length) {
        sessionStorage.setItem(value, param);
    }
    else {
        param = sessionStorage.getItem(value);
    }
    return param;
}
exports.extractParam = extractParam;
if (typeof window !== 'undefined') {
    window.MagaluService = MagaluService;
}
